import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import LocationData from "./LocationData";
import DropdownSelect from "../../../FormElement/DropdownSelect";
import {
  KeywordReviewCrossAnalysisData,
  KeywordReviewCrossAnalysisLocationData,
} from "../types/keywordReviewCrossAnalysisData";

import "./styles.scss";

interface IKeywordReviewCrossAnalysisProps {
  data: KeywordReviewCrossAnalysisData | undefined;
}

const KeywordReviewCrossAnalysis: React.FunctionComponent<
  IKeywordReviewCrossAnalysisProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`EXPERIMENTAL_organizationFeaturesPage.${key}`);
  const { data } = props;
  const locationData = data?.locationData ?? [];

  const locationNames = locationData.map(
    (location: KeywordReviewCrossAnalysisLocationData) => location.location_name
  );

  const [selectedLocationIndex, setSelectedLocationIndex] = useState<number>(0);

  const selectedLocationData = locationData[selectedLocationIndex];

  if (!data) {
    return null;
  }

  if (data?.status === "generating") {
    return (
      <div className="keyword-review-cross-analysis-container">
        {t("generating")}
      </div>
    );
  }

  return (
    <div className="keyword-review-cross-analysis-container">
      <DropdownSelect
        value={locationNames[selectedLocationIndex]}
        items={locationNames}
        onChange={(value) =>
          setSelectedLocationIndex(locationNames.indexOf(value))
        }
      />
      {selectedLocationData && selectedLocationData.keywords.length > 0 ? (
        <LocationData locationData={selectedLocationData} />
      ) : (
        <div className="no-data-message">{t("no_keywords_found")}</div>
      )}
    </div>
  );
};

export default KeywordReviewCrossAnalysis;
